var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconCartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.939 1a.927.927 0 00-.813.456.915.915 0 000 .928c.168.287.479.46.813.456h1.738c.21 0 .384.13.443.33L7.064 16.5a2.78 2.78 0 002.663 1.98h10.158c1.247 0 2.35-.838 2.678-2.034l2.404-8.763a.916.916 0 00-.157-.801.927.927 0 00-.736-.362H6.041L4.897 2.651h-.002a2.318 2.318 0 00-2.218-1.65H.94zm9.254 19.32c-1.022 0-1.85.824-1.85 1.84S9.17 24 10.192 24s1.85-.824 1.85-1.84-.828-1.84-1.85-1.84zm9.254 0c-1.022 0-1.85.824-1.85 1.84s.828 1.84 1.85 1.84c1.022 0 1.851-.824 1.851-1.84s-.829-1.84-1.85-1.84z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgCommonIconCartFilled;